<template>
  <img
    :fetchpriority="fetchPriority"
    :width="width"
    :height="height"
    :src="src"
    :alt="alt"
    :class="classes"
    :decoding="decoding"
    :loading="loading"
  />
</template>

<script setup lang="ts">
/** types */
import type {
  TImageDecoding,
  TImageFetchPriority,
  TImageLoading,
} from '~/src/types/common'

withDefaults(
  defineProps<{
    src: string
    fetchPriority?: TImageFetchPriority
    classes: string
    decoding?: TImageDecoding
    loading?: TImageLoading
    alt: string
    width?: string
    height?: string
  }>(),
  {
    fetchPriority: 'low',
    decoding: 'auto',
    loading: 'lazy',
    width: 'auto',
    height: 'auto',
  },
)
</script>
